export const getProductsQuery = `query GetCanonicals($org_id: String! $since: String! $before: String! $limit: String $needs_resolving: Boolean $operation_type: String $next_token: String) {
    products (
        org_id: $org_id,
        since: $since,
        before: $before,
        limit: $limit,
        needs_resolving: $needs_resolving,
        operation_type: $operation_type,
        next_token: $next_token,
        is_composite: true
    ) 
    {   
        product_id,
        description,
        aliases{
            id, 
            instance_system_id, 
            model_scope,
            system_type
        },
        form,
        product_type,
        product_components{
            product_ref,
            is_carrier,
            quantity{value}
        },
        total_instance_count
    }
}`;
